module.exports = __webpack_public_path__ + "img/lighthouse-homepage-graphics.cd22a9a9.svg";